let productId = document.querySelector("[data-product-id]").dataset.productId;
let productHandle = document.querySelector("[data-product-id]").dataset.productHandle;
let shopName = window.Shopify.shop.replace(".myshopify.com", "");
let sizeMetaobjectBlock = document.querySelector("[data-size-metaobject-block]");
let url = `https://nonfiction-server.lukuku.co/api/product-referenced-by-bundle-metaobject?product_id=${productId}&store_name=${shopName}`;
let getProductMetaobjectRef = async () => {
  try {
    let response = await fetch(url, { method: "GET" });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    let data = await response.json();
    sizeMetaobjectBlock.innerHTML = "";
    data.forEach((item) => {
      let linkElement = document.createElement("a");
      linkElement.href = `/products/${item.handle}`;
      linkElement.className = `product-size__link ${productHandle == item.handle ? "product-size__link-active" : ""
        }`;
      linkElement.textContent = item.label;
      sizeMetaobjectBlock.appendChild(linkElement);
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
getProductMetaobjectRef();
const selects = document.querySelectorAll("[data-variant-wrap]");
if (selects.length > 0) {
  selects.forEach((item) => {
    item.addEventListener("change", () => {
      checkBoth();
    });
  });
}
const checkBoth = () => {
  const messageCard = document.querySelector("[data-message-card1] [data-message-change]");
  const pump = document.querySelector("[data-message-card2] [data-message-change]");
  const scent = document.querySelector("[data-message-card3] [data-message-change]");
  const findSelect = document.querySelector("[data-find-bundle]");
  const hiddenInput = document.querySelector("[data-form-variant-id]");
  Array.from(findSelect.options).forEach((option) => {
    const optionText = option.textContent || option.innerText;
    if (
      optionText.includes(messageCard.value) &&
      (!pump || optionText.includes(pump.value)) &&
      (!scent || optionText.includes(scent.value))
    ) {
      option.selected = true;
    }
  });
  hiddenInput.value = findSelect.value;
};
const SHOPIFY_STORE_NAME_JP = "nonfiction-jp";
const SHOPIFY_ACCESS_TOKEN_JP = "bc110a2a11b0355a3b92965548c78a7e";
const API_VERSION_JP = "2024-10";
const API_URL_JP = `https://${SHOPIFY_STORE_NAME_JP}.myshopify.com/api/${API_VERSION_JP}/graphql.json`;
function parseLegacyIdFromGID(gid) {
  return parseInt(gid.split("/").pop(), 10);
}
async function shopifyGraphqlRequest(query, variables) {
  const resp = await fetch(API_URL_JP, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": SHOPIFY_ACCESS_TOKEN_JP,
    },
    body: JSON.stringify({ query, variables }),
  });
  if (!resp.ok) {
    const errorText = await resp.text();
    throw new Error(`Shopify GraphQL Error: ${resp.status} / ${errorText}`);
  }
  return resp.json();
}
const inputData = [];
const scent = document.querySelector('[data-variant-selector]')
if (scent) {
  document?.querySelectorAll("[data-variant-selector],[data-get-select-message-card]")?.forEach((single) => {
    single.addEventListener("change", () => {
      get_variant_ids();
      processInputData();
    });
  });
} else {
  document?.querySelectorAll("[data-get-select-pump],[data-get-select-message-card]")?.forEach((single) => {
    single.addEventListener("change", () => {
      get_variant_ids();
      processInputData();
    });
  });
}
const get_variant_ids = () => {
  const payload = [];
  const messageCardPayload = [];
  const mainProductElement = document.querySelector("[data-main-product]");
  const scent = document.querySelector('[data-variant-selector]')
  if (scent) {
    if (mainProductElement) {
      const defaultProductId = mainProductElement.dataset.productId;
      const defaultVariantId = scent[scent.selectedIndex].dataset.variant;
      if (defaultProductId && defaultVariantId) {
        payload.push({
          product_id: defaultProductId,
          product_variant_id: defaultVariantId,
        });
      }
      const message_card = document.querySelector("[data-get-select-message-card]")
      const selectedOption = message_card.options[message_card.selectedIndex];
      const productId = message_card.dataset.productId;
      const variantId = selectedOption.dataset.variant;
      if (productId && variantId) {
        if (message_card.hasAttribute("data-get-select-message-card")) {
          messageCardPayload.push({ product_id: productId, product_variant_id: variantId });
        } else {
          payload.push({ product_id: productId, product_variant_id: variantId });
        }
      }
    }
  } else {
    if (mainProductElement) {
      const defaultProductId = mainProductElement.dataset.productId;
      const defaultVariantId = mainProductElement.dataset.variant;
      if (defaultProductId && defaultVariantId) {
        payload.push({
          product_id: defaultProductId,
          product_variant_id: defaultVariantId,
        });
      }
      document
        ?.querySelectorAll("[data-get-select-pump],[data-get-select-message-card]")
        ?.forEach((single) => {
          const selectedOption = single.options[single.selectedIndex];
          const productId = single.dataset.productId;
          const variantId = selectedOption.dataset.variant;
          if (productId && variantId) {
            if (single.hasAttribute("data-get-select-message-card")) {
              messageCardPayload.push({ product_id: productId, product_variant_id: variantId });
            } else {
              payload.push({ product_id: productId, product_variant_id: variantId });
            }
          }
        });
    }
  }
  inputData.length = 0;
  inputData.push(...payload, ...messageCardPayload);
};
const processInputData = async () => {
  if (!inputData.length) return;
  const productIds = inputData.map((item) => item.product_id);
  const queryProductTypeValue = `DefaultBundle\\:${productIds.join("\\:")}`;
  const productTypeValue = queryProductTypeValue.replace(/\\/g, "");
  const QUERY = `
    query($queryString: String!) {
      products(first: 250, query: $queryString) {
        edges {
          node {
            productType
            id
            variants(first: 250) {
              edges {
                node {
                  id
                  components(first: 250) {
                    edges {
                      node {
                        productVariant {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
  try {
    const responseData = await shopifyGraphqlRequest(QUERY, {
      queryString: `product_type:${queryProductTypeValue}`,
    });
    const productEdges = responseData?.data?.products?.edges || [];
    const firstExactEdge = productEdges.find(
      (edge) => edge.node.productType === productTypeValue
    );
    if (!firstExactEdge) {
      setDefaultVariant();
      return null;
    }
    const productNode = firstExactEdge.node;
    const variants = (productNode.variants?.edges || []).map((variantEdge) => {
      const { id, components } = variantEdge.node;
      return {
        id,
        components: (components?.edges || []).map((compEdge) => compEdge.node.productVariant.id),
      };
    });
    const desiredGids = inputData.map(
      (item) => `gid://shopify/ProductVariant/${item.product_variant_id}`
    );
    for (const variant of variants) {
      const matchedCount = variant.components.filter((compId) => desiredGids.includes(compId)).length;
      if (matchedCount === desiredGids.length) {
        const legacyId = parseLegacyIdFromGID(variant.id);
        document.querySelector("[data-form-variant-id]").value = legacyId;
        return legacyId;
      }
    }
    setDefaultVariant();
    return null;
  } catch (error) {
    console.error("Error in processInputData:", error.message);
    return null;
  }
};
function setDefaultVariant() {
  const mainProductElement = document.querySelector("[data-main-product]");
  if (!mainProductElement) return;
  const defaultVariantId = mainProductElement.dataset.variant;
  if (!defaultVariantId) return;
  document.querySelector("[data-form-variant-id]").value = defaultVariantId;
}